import { createSelector } from "reselect"
import { get, map, chain, pick } from "lodash"
import { canSegmentBeDisplayed } from "../helpers"
import { getIsActive, getPositionSets } from "."

export const getItems = createSelector(
  [getPositionSets],
  (positionSets) => map(positionSets, (ps, index) => ({
    id: String(index),
    disabled: ps.isUnmodeled,
    ...pick(ps, ["label", "color", "noData", "isUnmodeled"]),
  })),
)

export const getChartItems = createSelector(
  [getItems, getPositionSets, getIsActive],
  (items, positionSets, isActive) => chain(items)
    .map((item, index) => canSegmentBeDisplayed(get(positionSets, index), isActive) ? item : undefined)
    .compact()
    .value(),
)
